import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";

import { constants } from '../../../../Helpers/Constants';
import { DivisionIcon, VCIcon } from '../../../Common/Buttons/TypeIcons';
import ProfileCell from '../User/ProfileCell';
import { Ellipsis } from '../../../Common/Buttons/Icons';

//Pass a profile prop with the necessary details
class UserAdminRow extends Component {
    constructor(props) {
        super(props);

        this.renderUserOptions = this.renderUserOptions.bind(this);
        this.addUserAccess = this.addUserAccess.bind(this);
        this.editUser = this.editUser.bind(this);
        this.activateUser = this.activateUser.bind(this);
        this.deactivateUser = this.deactivateUser.bind(this);
        this.disableAccess = this.disableAccess.bind(this);
        this.enableAccess = this.enableAccess.bind(this);

        this.state = {
            dropdown: false
        };
    }

    componentDidMount() {
    }

    setUserStatusIcon(user) {
        if (user.parsed_status === 'Active') {
            return(
                <img src = "images/user/status/approved.png"/>
            )
        } else if (user.parsed_status === 'Inactive') {
            return(
                <img src = "images/user/status/deactivated.png"/>
            )
        }
    }

    renderUserOptions(user, i) {
        if (user.parsed_status === 'Active') {
            return(
                <div className = {"list-action-dropdown" + (this.state.dropdown ? "" : " is-hidden")} style = {{right:'0px'}}>
                    <ul>
                        <li>
                            <span className = "float-left" onClick={(e) => this.addUserAccess(e, user.profile.user.ID, i)}>Add Access</span>
                            <div className = "clearfix"></div>
                        </li>
                        <li>
                            <span className = "float-left" onClick={(e) => this.disableAccess(e, user.profile.user.ID, user.ID, i)}>Disable Access</span>
                            <div className = "clearfix"></div>
                        </li>
                        <li>
                            <span className = "float-left" onClick={(e) => this.deactivateUser(e, user.profile.user.ID, i)}>Deactivate User</span>
                            <div className = "clearfix"></div>
                        </li>
                    </ul>
                </div>
            )
        } else if (user.parsed_status === 'Inactive') {
            return(
                <div className = {"list-action-dropdown" + (this.state.dropdown ? "" : " is-hidden")} style = {{right:'0px'}}>
                    <ul>
                        <li>
                            <span className = "float-left" onClick={(e) => this.activateUser(e, user.profile.user.ID, i)}>Activate User</span>
                            <div className = "clearfix"></div>
                        </li>
                    </ul>
                </div>
            )
        } else if (user.parsed_status === "Disabled") {
            return(
                <div className = {"list-action-dropdown" + (this.state.dropdown ? "" : " is-hidden")} style = {{right:'0px'}}>
                    <ul>
                        <li>
                            <span className = "float-left" onClick={(e) => this.addUserAccess(e, user.profile.user.ID, i)}>Add Access</span>
                            <div className = "clearfix"></div>
                        </li>
                        <li>
                            <span className = "float-left" onClick={(e) => this.deactivateUser(e, user.profile.user.ID, i)}>Deactivate User</span>
                            <div className = "clearfix"></div>
                        </li>
                    </ul>
                </div>
            )
        }
    }

    toggleActionDropdown() {
        this.setState({
            dropdown: !this.state.dropdown
        })
    }

    addUserAccess(e, id, i) {
        this.toggleActionDropdown("user-dropdown-" + i)
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/create/shuseraccess/' + id)
    }

    editUser(e, id, view_id) {
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/shuser/' + id + '/' + view_id)
    }

    activateUser(e, id, i) {
        e.stopPropagation();
        var self = this;

        axios.post('/ajax/user/' + id + '/activate')
        .then((response) => {
            self.toggleActionDropdown("user-dropdown-" + i)
            showStatusMsg(response?.data.message, 'success');
            self.updateUsers(e);
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    deactivateUser(e, id, i) {
        e.stopPropagation();
        var self = this;

        axios.post('/ajax/user/' + id + '/deactivate')
        .then((response) => {
            self.toggleActionDropdown("user-dropdown-" + i)
            showStatusMsg(response?.data.message, 'success');
            self.updateUsers(e);
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    disableAccess(e, user_id, view_id, i) {
        e.stopPropagation();
        var self = this;

        axios.post('/ajax/user/' + user_id + '/disable/' + view_id)
        .then((response) => {
            self.toggleActionDropdown("user-dropdown-" + i)
            showStatusMsg(response?.data.message, 'success');
            self.updateUsers(e);
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    enableAccess(e, user_id, view_id, i) {
        e.stopPropagation();
        var self = this;

        axios.post('/ajax/user/' + user_id + '/enable/' + view_id)
        .then((response) => {
            self.toggleActionDropdown("user-dropdown-" + i)
            showStatusMsg(response?.data.message, 'success');
            self.updateUsers(e);
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }
    
    render() {
        return (
            <tr className={this.props.user.parsed_status === "Inactive" ? "row-grey" : ""}>
                <td>
                    <ProfileCell history={this.props.history} match={this.props.match} location={this.props.location} profile={this.props.user.profile} noTooltip={true} onclick={(e) => this.editUser(e, this.props.user.profile.user.ID, this.props.user.ID)} showImage />
                </td>
                <td className = "single-img-cell">
                    {this.setUserStatusIcon(this.props.user)}
                </td>
                <td className = "multi-img-cell px-26">
                    {VCIcon(this.props.user.vmh, null, null, null, true)}
                </td>
                <td className = "multi-img-cell px-26">
                    {DivisionIcon(this.props.user.stakeholder, null, null, null, true)}
                </td>
                <td style={{textTransform: "capitalize"}} onClick={(e) => this.editUser(e, this.props.user.profile.user.ID, this.props.user.ID)}>
                    { this.props.user.User_Type == 0 ? "VC" : (this.props.user.User_Type == 1 ? "Stakeholder" : null) }
                </td>
                <td style={{textTransform: "capitalize"}} onClick={(e) => this.editUser(e, this.props.user.profile.user.ID, this.props.user.ID)}>
                    { (Object.keys(constants.user_role)[(this.props.user.User_Role - 1)]).replace(/_/g, " ") }
                </td>
                <td className = "action-cell">
                    <div className = "list-action-wrapper">
                        <a onClick={() => this.toggleActionDropdown()}>
                            {Ellipsis()}
                        </a>
                        {
                            this.renderUserOptions(this.props.user, this.props.i)
                        }
                    </div>
                </td>
            </tr>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(UserAdminRow)